import Vue from 'vue'

import {
    forEach as _forEach,
    groupBy as _groupBy,
    orderBy as _orderBy,
} from 'lodash'

import RepairModel from '@/models/RepairModel'

import RepairService from '@/services/repair.service'

// -----------------------------------------------------------------------------

const state = {
    repairs: {},
    isLoading: false,
}

const getters = {
    getRepairs: state => {
        return _orderBy(state.repairs, item => Number(item.sort) || 0, ['asc'])
    },

    getRepair: state => repairId => {
        return state.repairs[repairId] || null
    },
}

const mutations = {
    setRepairs(state, payload) {
        state.repairs = {}

        const repairsGroupedById = _groupBy(payload, 'id')

        _forEach(repairsGroupedById, items => {
            const repairData = {
                stationIds: [],
            }

            _forEach(items, item => {
                repairData.id = item.id
                repairData.name = item.name
                repairData.typeName = item.typeName
                repairData.description = item.description
                repairData.stationIds.push(item.stationId)
            })

            const repair = new RepairModel(repairData)

            Vue.set(state.repairs, repair.id, repair)

            if (repair.type) {
                this.commit('repairType/setRepairType', {
                    id: repair.type,
                    name: repair.type,
                })
            }
        })
    },

    setIsLoading(state, payload) {
        state.isLoading = !!payload
    },
}

const actions = {
    fetch({ commit }) {
        commit('setIsLoading', true)
        return new Promise((resolve, reject) => {
            RepairService.getRepairs()
                .then(response => {
                    commit('setRepairs', response.response.items)
                    commit('setIsLoading', false)

                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
